import { render, staticRenderFns } from "./BindsListItemLink.vue?vue&type=template&id=57d20a66&"
import script from "./BindsListItemLink.vue?vue&type=script&lang=js&"
export * from "./BindsListItemLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports